export enum LoanOriginationSystemProductConfigurationType {
  SelectProduct = 'loanOriginationSystemProductConfigurationType/selectProduct',
  SetCurrentStep = 'loanOriginationSystemProductConfigurationType/setCurrentStep',
  ResetProductConfiguration = 'loanOriginationSystemProductConfigurationType/resetProductConfiguration',
}
